import { red } from '@mui/material/colors'
import React from 'react'

const ChunkedPlanRooms = ({ item, colorCode }) => {
  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  let ch = chunk(item.rooms, 22);
  return (
    <>
      <tr>
        <th rowSpan={ch.length * 2} style={{ background: "#f8cbae", padding: 4 }}>{item.floorName}</th>
        <th style={{ background: '#f9e6d5', fontSize: '12px', padding: 4 }}>شماره اتاق</th>
        {
          ch[0].map((room, i) => (
            <td dir='ltr' style={{ backgroundColor: colorCode, padding: 4 }}>{room.roomNumber}</td>

          ))}
      </tr>
      <tr>
        <th style={{ background: '#f9e6d5', fontSize: '12px', padding: 4 }}>تعداد تخت</th>
        {ch[0].map((room, i) => (
          <td><span style={room?.bedCount == 3 ? { color: red[500] } : { color: 'black' }}>{room.bedCount}</span></td>
        ))}
      </tr>
      {
        ch.slice(1, 500).map((chitem) => (
          <>
            <tr>
              <th style={{ background: '#f9e6d5', fontSize: '12px', padding: 4 }}>شماره اتاق</th>
              {chitem.map((item) => (
                <td dir='ltr' style={{ backgroundColor: colorCode, padding: 4 }}>{item.roomNumber}</td>
              ))}
            </tr>
            <tr>
              <th style={{ background: '#f9e6d5', fontSize: '12px', padding: 4 }}>تعداد تخت</th>
              {chitem.map((room, i) => (
                <td><span style={room?.bedCount == 3 ? { color: red[500] } : { color: 'black' }}>{room.bedCount}</span></td>
              ))}
            </tr>
          </>
        ))
      }
    </>



  )
}

export default ChunkedPlanRooms